import { render } from "./CargaArchivosReportesRemedy.vue?vue&type=template&id=cb9ff9de"
import script from "./CargaArchivosReportesRemedy.vue?vue&type=script&lang=js"
export * from "./CargaArchivosReportesRemedy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__